import { setDefaultDateFormattingLocale } from '@mnd-frontend/dates';
import { UserLocale } from '@mnd-frontend/graphql-schema';
import { getCookie } from '@mnd-frontend/utils';
import i18next from 'i18next';
import Fetch from 'i18next-fetch-backend';
import Cache from 'i18next-localstorage-cache';
import { initReactI18next } from 'react-i18next';
import { isProduction } from '../../lib/environment';

const loadPath = ([import.meta.env.VITE_LOCALE_FILES_URL, '%{lng}.json'] as string[])
  .map(path => path.replace(/\/+$/, ''))
  .join('/');

export const defaultLocale = UserLocale.En;
export const locales = {
  en: 'en-gb',
  de: 'de',
  da: 'da',
  fi: 'fi',
  no: 'no',
  sv: 'sv',
} as const;

const rule = {
  numbers: [0, 1, 2],
  plurals: (num: number) => Number(num !== 1 ? 2 : num),
};

i18next.on('initialized', () => {
  Object.entries(locales).map(([locale]) => i18next.services.pluralResolver.addRule(locale, rule));
});

export const initI18n = () => {
  const locale = getCookie('locale') || defaultLocale;
  const showKeys = locale === 'keys';

  i18next
    .use(Fetch)
    .use(Cache)
    .use(initReactI18next)
    .init(
      {
        lng: showKeys ? 'cimode' : locale,
        fallbackLng: false,
        ns: [],
        defaultNS: '',
        pluralSeparator: '.',
        interpolation: {
          escapeValue: false,
          prefix: '%{',
          suffix: '}',
        },
        react: {
          transKeepBasicHtmlNodesFor: [
            'br',
            'div',
            'strong',
            'b',
            'i',
            'p',
            'ol',
            'ul',
            'li',
            'code',
          ],
        },
        backend: {
          loadPath,
        },
        cache: {
          enabled: isProduction,
          prefix: 'mnd_res_',
          versions: {
            en: import.meta.env.VITE_BUILD_VERSION,
            de: import.meta.env.VITE_BUILD_VERSION,
            da: import.meta.env.VITE_BUILD_VERSION,
            fi: import.meta.env.VITE_BUILD_VERSION,
            no: import.meta.env.VITE_BUILD_VERSION,
            sv: import.meta.env.VITE_BUILD_VERSION,
          },
        },
      },
      err => {
        setDefaultDateFormattingLocale(
          locale in locales ? locales[locale as keyof typeof locales] : undefined,
        );
        if (err) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
      },
    );
};
